import { createAction, props } from '@ngrx/store';
import { ApiError } from '@hrra/core';
import { JobseekerLookupViewModel, JobseekerSpecializationViewModel, JobseekerSubscriptionUpdateViewModel, JobseekerSubscriptionViewModel } from 'src/app/jobseeker/shared/services/jobseeker.service';
import { SubscriberRegistrationRequestViewModel, SubscriberRegistrationResponseViewModel, SubscriptionUpdateViewModel, SubscriptionViewModel } from 'src/app/subscriber/shared/services/subsriber.service';
import { ActionPayload } from "@hrra/core";

export enum Actions {

    LoadSubscription = '[Jobseeker subscription page] Load subscription',
    LoadSubscriptionSuccess = '[Jobseeker subscription page] Load subscription success',
    LoadSubscriptionFail = '[Jobseeker subscription page] Load subscription fail',

    LoadJobseekerSubscriptionLookup = '[Edit jobseeker subscription page] load jobseeker subscription lookup',
    LoadJobseekerSubscriptionLookupSuccess = '[Edit jobseeker subscription page] load jobseeker subscription lookup success',
    loadJobseekerSubscriptionLookupFail = '[Edit jobseeker subscription page] load jobseeker subscription lookup fail',

    UpdateSubscription = '[Edit jobseeker subscription page] Update subscription',
    UpdateSubscriptionSuccess = '[Edit jobseeker subscription page] Update subscription success',
    UpdateSubscriptionFail = '[Edit jobseeker subscription page] Update subscription fail',

    UpdateSelectedSpecializations = '[Jobseeker subscription page] Update selected specializations',

    ActivateEditMode = '[Jobseeker subscription page] Activate edit mode',

    UnsubscribeJobseeker = '[Jobseeker subscription page] Unsubscribe Jobseeker',
    UnsubscribeJobseekerSuccess = '[Jobseeker subscription page] Unsubscribe Jobseeker success',
    UnsubscribeJobseekerFail = '[Jobseeker subscription page] Unsubscribe Jobseeker fail'


}

export const loadSubscription = createAction(
    Actions.LoadSubscription
);

export const loadSubscriptionSuccess = createAction(
    Actions.LoadSubscriptionSuccess,
    props<ActionPayload<JobseekerSubscriptionViewModel>>()
);

export const loadSubscriptionFail = createAction(
    Actions.LoadSubscriptionFail,
    props<ActionPayload<ApiError>>()
);

export const loadJobseekerSubscriptionLookup = createAction(
    Actions.LoadJobseekerSubscriptionLookup,
);

export const loadJobseekerSubscriptionLookupSuccess = createAction(
    Actions.LoadJobseekerSubscriptionLookupSuccess,
    props<ActionPayload<JobseekerLookupViewModel>>()
);

export const loadJobseekerSubscriptionLookupFail = createAction(
    Actions.loadJobseekerSubscriptionLookupFail,
    props<ActionPayload<ApiError>>()
);

export const updateSubscription = createAction(
    Actions.UpdateSubscription,
    props<ActionPayload<JobseekerSubscriptionUpdateViewModel>>()
);

export const updateSubscriptionSuccess = createAction(
    Actions.UpdateSubscriptionSuccess,
    props<ActionPayload<JobseekerSubscriptionViewModel>>()
);

export const updateSubscriptionFail = createAction(
    Actions.UpdateSubscriptionFail,
    props<ActionPayload<ApiError>>()
);

export const updateSelectedSpecializations = createAction(
    Actions.UpdateSelectedSpecializations,
    props<ActionPayload<{ specialization: JobseekerSpecializationViewModel, checked: boolean}>>()
);

export const unsubscribeJobseeker = createAction(
    Actions.UnsubscribeJobseeker
)

export const unsubscribeJobseekerSuccess = createAction(
    Actions.UnsubscribeJobseekerSuccess
)

export const unsubscribeJobseekerFail = createAction(
    Actions.UnsubscribeJobseekerFail,
    props<ActionPayload<ApiError>>()
)

export const activateEditMode = createAction(
    Actions.ActivateEditMode
);
